// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"8d84544f","977":"a09edf7f"}[chunkId] + ".chunk.js";
};